import { getComponentsFromGlobMap } from '@zto/tuxi-operate-web-base'

const componentsMap: Record<string, any> = import.meta.globEager(`../components/**/C*.vue`)

const components = getComponentsFromGlobMap(componentsMap)

export { components }
